
import CreateTag from './createTag.vue';

export default {
  components: {
    CreateTag: CreateTag
  },

  props: {
    onSuccess: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      visible: false
    };
  },


  watch: {
    visible: function visible() {
      this.$refs['create-tag'].resetFields();
    }
  },

  methods: {
    handleCreateSuccess: function handleCreateSuccess() {
      this.visible = false;
      this.onSuccess();
    },
    handleCreateCancel: function handleCreateCancel() {
      this.visible = false;
    }
  }
};